export const DeleteChatModal = ({ chatToDelete, onCancel, onConfirm }) => {
    return (
        <div className="deleteModalOverlay" onClick={onCancel}>
            <div className="deleteModal" onClick={(e) => e.stopPropagation()}>
                <div className="modalHeader">
                    <h3>
                        Delete the conversation?
                    </h3>
                </div>

                <div className="modalBody">
                    <p>
                        Are you sure you want to delete the conversation with
                        
                        <strong> 
                            {chatToDelete?.receiverName}
                        </strong>?
                    </p>

                    <p className="warningText">
                        This action cannot be undone.
                    </p>
                </div>

                <div className="modalFooter">
                    <button className="btnCancel" onClick={onCancel}>
                        Cancel
                    </button>

                    <button className="btnDelete" onClick={onConfirm}>
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};